"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useCheckIntegrationsReconnect = void 0;

var _react = require("react");

var _reactRedux = require("react-redux");

var _gift = require("../store/gift/gift.actions");

var _gift2 = require("../store/gift/gift.selector");

var useCheckIntegrationsReconnect = function useCheckIntegrationsReconnect() {
  var dispatch = (0, _reactRedux.useDispatch)();
  var giftId = (0, _reactRedux.useSelector)(_gift2.getGiftId);
  var template = (0, _reactRedux.useSelector)(_gift2.getGiftEmailTemplate);
  var onIntegrationConnected = (0, _react.useCallback)(function (event) {
    if (event.data === 'IntegrationConnected') {
      dispatch((0, _gift.giftRefreshRequest)(giftId, template));
    }
  }, [dispatch, giftId, template]);
  (0, _react.useEffect)(function () {
    window.addEventListener('message', onIntegrationConnected);
    return function () {
      window.removeEventListener('message', onIntegrationConnected);
    };
  }, [onIntegrationConnected]);
};

exports.useCheckIntegrationsReconnect = useCheckIntegrationsReconnect;